import React from 'react';
import { getVolumeManager } from '../../../getVolumeManager';
import CustomInputBox from '../../Common/CustomInputBox';


const volumeManager3d = getVolumeManager();

const handleOnChange = (e) => {
  if (e.target.value > 0) {
    volumeManager3d.api.setVolSize(e.target.value);
  }
}

export const MPRThicknessInputBox = ({ toggleShowInputBox }) => {

  return (
    <CustomInputBox
      name={'MPRThicknessInputBox'}
      initialValue={''}
      label={'Thickness (mm)'}
      inputType={'number'}
      handleOnChange={handleOnChange}
      toggleShowInputBox={toggleShowInputBox}
    />
  );
};


export default MPRThicknessInputBox;
